import EmployeesRouter from "@/views/rrhh/views/employees/router/employees.router.js";
import PayrollRouter from "@/views/rrhh/views/payroll/router/payroll.router.js";
import ViaticRouter from "@/views/rrhh/views/viatic/router/viatic.router.js";
import ReportsRouter from "@/views/rrhh/views/reports/router/reports.router.js";

import RRHHMain from "@/views/rrhh/views/RRHHMain.vue";
import AumentoSueldoRouter from "@/views/rrhh/views/aumento-sueldo/router/aumento-sueldo.router.js";
import TrabajoAdicionalRouter from "@/views/rrhh/views/trabajo-adicional/router/trabajo-adicional.router.js";
const routes = [
  {
    path: "/rrhh",
    name: "rrhh",
    redirect: { name: "rrhh-employees" },
    meta: { module: 9 },
    component: RRHHMain,
    children: [
      ...EmployeesRouter,
      ...PayrollRouter,
      ...ViaticRouter,
      ...ReportsRouter,
      ...AumentoSueldoRouter,
      ...TrabajoAdicionalRouter
    ],
  },
];

export default routes;
